// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"711b1e14","239":"54380f6b","732":"6a9bf22e","977":"b161ae63"}[chunkId] + ".chunk.js";
};